import Admins from './Admin'
// import Users from './User'

export const Stages = { Admins }
export default Stages
